





































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import { SessionTemplate, Properties } from "./types";
import { createSession, updateSession, getSession } from "./sessionService";
import { bus } from "@/bus";
import { getAllFonts } from "@/services/fonts/fontsService";
import { Font } from "@/services/fonts/types";
import vSelect from "vue-select";
import i18n from "@/i18n";
import { FILEENDPOINT } from "@/app.config";
import { FolderEntites } from "@/services/folders/types";
import { TemplateTypeEnum } from "@/services/templates/types";
import DirectFileUploadControl from "@/components/common/files/DirectFileUploadControl.vue";
import { MediaType } from "@/services/files/types";

@Component({
    components: {
        DirectFileUploadControl,
        HeaderActionButtons,
        vSelect
    }
})
export default class SessionDesignForm extends Vue {
    @Prop() private sessionTemplateId!: string;
    @Prop() private folderId!: string;

    fonts = [] as Font[];
    languages = [{ name: i18n.t("dateFormats.danish"), value: "da" }, { name: i18n.t("dateFormats.englishUS"), value: "en" }, { name: i18n.t("dateFormats.swedish"), value: "sv" }, { name: i18n.t("dateFormats.norweigan"), value: "nb" }];
    localId = this.sessionTemplateId || "";

    mediaTypes = [MediaType.Image];
    sessionTemplate = {
        name: "",
        width: 1280,
        height: 800,
        folderId: this.folderId ? this.folderId : "",
        type: TemplateTypeEnum.sessions,
        properties: {
            background: "",
            backgroundName: "",
            logo: "",
            logoName: "",
            showUp: false,
            font: "Verdana",
            language: "",
            roomRelease: 15,
            orangeTime: 15,
            redTime: 5,
            blinkingIndicator: false,
            automaticDisplayOff: true,
            disableBooking: false,
            buttonColor: "#174e58",
            button1: {
                text: "",
                icon: "",
                iconName: "",
                hidden: false
            },
            button2: {
                text: "",
                icon: "",
                iconName: "",
                hidden: false
            },
            button3: {
                text: "",
                icon: "",
                iconName: "",
                hidden: false
            },
            button4: {
                text: "",
                icon: "",
                iconName: "",
                hidden: false
            }
        } as Properties
    } as SessionTemplate;

    folders = FolderEntites;

    created() {
        if (this.localId) {
            getSession(this.localId)
                .then(response => {
                    this.sessionTemplate = response;
                    bus.$emit("documentTitle", this.sessionTemplate.name);
                });
        }

        getAllFonts().then(response => {
            this.fonts = response;
            if (response.filter(x => x.technicalName.includes("verdana")).length < 1) {
                this.fonts.unshift({ technicalName: "verdana", displayName: "Verdana" } as Font);
            }
        });
    }

    back() {
        this.$router.go(-1);
    }

    openFileSelection(): void {
        (this.$refs.fileInput as any).click();
    }

    get fileEndpoint(): string {
        return FILEENDPOINT;
    }

    save(back: boolean) {
        if (!this.localId) {
            createSession(this.sessionTemplate).then((id: string) => {
                if (back) this.$router.push({ path: `/templates?folder=${this.sessionTemplate.folderId}` });
                else {
                    this.localId = id;
                    this.sessionTemplate.id = id;
                }
            });
        } else {
            updateSession(this.sessionTemplate).then(() => {
                if (back) this.$router.push({ path: `/templates?folder=${this.sessionTemplate.folderId}` });
            });
        }
    }

    removeFile(key: string) {
        (this.$refs[key + "DirectUpload"] as any).removeFile();
        if (key.includes("button")) {
            (this.sessionTemplate.properties as any)[key].icon = "";
            (this.sessionTemplate.properties as any)[key].iconName = "";
            return;
        }
        (this.sessionTemplate.properties as any)[key] = "";
        (this.sessionTemplate.properties as any)[key + "Name"] = "";
    }

    uploadFile(key: string, file: any) {
        if (key.includes("button")) {
            (this.sessionTemplate.properties as any)[key].icon = file.fileId;
            (this.sessionTemplate.properties as any)[key].iconName = file.name;
            return;
        }
        (this.sessionTemplate.properties as any)[key] = file.fileId;
        (this.sessionTemplate.properties as any)[key + "Name"] = file.name;
    }
}
